import React from 'react';
import { TEXT_VARIANTS } from 'components/ui/Typography/Text';
import VersionHistoryInfo from './VersionHistoryInfo';

const ScormLessonVersionList = ({ versions, lastLiRef }) => {
  const currentVersion = versions[0].id;
  return (
    <ul>
      <li className="PublishedVersionCollection-columnHeader d-f ff-ss fw-b fz-16">
        <span className="ml-32">{t('versions.update_information')}</span>
      </li>
      {versions &&
        versions.map((v, versionIndex) => (
          <li
            ref={versionIndex === versions.length - 1 ? lastLiRef : null}
            key={v.id}
            className="PublishedVersionCollection-dataRow h-bc-gray-lightest py-16 d-f pl-32 pr-58"
          >
            <div className="mr-32">
              <VersionHistoryInfo
                version={v}
                currentVersion={currentVersion}
                textVariant={TEXT_VARIANTS.BODY}
              />
            </div>
          </li>
        ))}
    </ul>
  );
};

export default ScormLessonVersionList;
